<app-dashboard-option [categories]="['LAYOUT']" [label]="'COLUMNS'" [information]="'PIXEL'">
  <div app-dashboard-option-content>
    <app-number [value]="dashboardLayout.columns" (sendValue)="receiveValue($event)" [color]="color" [min]="1" [max]="200" [step]="5"></app-number>
  </div>
</app-dashboard-option>